import script from "./UserReportChart.vue?vue&type=script&lang=js"
export * from "./UserReportChart.vue?vue&type=script&lang=js"

export default script